import * as z from "zod/v4";

export const resetBillingAutoReloadDisabled = {
  name: "resetBillingAutoReloadDisabled" as const,
  input: z.object({}),
  output: z.object({ success: z.boolean() }),
};
